export default __webpack_public_path__ + "static/Nocode-01 1-b6ec2c78eaffe45c8a6ce4677bf6cb66.png";